import type { IconProps } from './types';

export const Download = ({ size, ...props }: IconProps) => (
  <svg
    width={size}
    height={size ? size * 1.05 : size}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.6802 8.65C17.7702 7.52 16.3602 6.89 14.3902 6.72C13.9902 6.69 13.6302 6.98 13.6002 7.39C13.5702 7.79 13.8602 8.15 14.2702 8.18C15.8502 8.32 16.8902 8.76 17.5502 9.57C18.2202 10.39 18.5402 11.68 18.5402 13.5V13.63C18.5402 15.65 18.1602 16.98 17.3402 17.8C16.5202 18.62 15.2002 19 13.1702 19H6.83023C4.81023 19 3.48023 18.62 2.66023 17.8C1.84023 16.98 1.46023 15.66 1.46023 13.63V13.5C1.46023 11.69 1.78023 10.41 2.44023 9.59C3.09023 8.78 4.11023 8.33 5.66023 8.19C6.06023 8.15 6.36023 7.8 6.32023 7.39C6.28023 6.99 5.93023 6.69 5.52023 6.73C3.58023 6.91 2.19023 7.55 1.29023 8.67C0.400234 9.78 -0.00976562 11.31 -0.00976562 13.49V13.62C-0.00976562 16.05 0.510234 17.71 1.62023 18.82C2.73023 19.93 4.38023 20.45 6.82023 20.45H13.1602C15.5902 20.45 17.2502 19.93 18.3602 18.82C19.4702 17.71 19.9902 16.06 19.9902 13.62V13.49C19.9902 11.29 19.5702 9.75 18.6702 8.64L18.6802 8.65Z"
      fill="currentColor"
    />
    <path
      d="M6.22023 11.62L9.48023 14.88C9.62023 15.02 9.80023 15.09 10.0002 15.09C10.2002 15.09 10.3802 15.01 10.5202 14.88L13.7802 11.62C14.0702 11.33 14.0702 10.87 13.7802 10.59C13.4902 10.31 13.0302 10.3 12.7502 10.59L10.7302 12.61V0.73C10.7302 0.33 10.4002 0 10.0002 0C9.60023 0 9.27024 0.33 9.27024 0.73V12.6L7.25023 10.58C6.96023 10.29 6.50023 10.29 6.22023 10.58C5.93023 10.87 5.93023 11.33 6.22023 11.61V11.62Z"
      fill="currentColor"
    />
  </svg>
);
